import { type ListData } from 'liftApp/types';
import type { Translate } from 'next-translate';
import React from 'react';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import { MyImage } from '@/components/elements/MyImage';
import styles from './CardItem.module.scss';

interface Props {
	slide: ListData;
	t: Translate;
}
export const CardItem: React.FC<Props> = ({ slide, t }) => {
	// Destructure
	const { href, image, title, alt } = slide;

	return (
		<div className={styles['slide']} data-card='true'>
			<LinkWithQuery
				href={href ?? ''}
				className={styles['slide__link']}
				aria-label={t(title)}
			>
				<article className={styles['slide__card']}>
					<div className={styles['slide__image-wrapper']}>
						<MyImage
							imageProps={{
								src: image,
								alt: t(alt),
								title: t(title),
								loading: 'lazy',
							}}
							settings={{
								classes: {
									picture: styles['slide__picture'],
									image: styles['slide__image'],
								},
							}}
						/>
					</div>
					<h3 className={styles['slide__card-title']}>{t(title)}</h3>
				</article>
			</LinkWithQuery>
		</div>
	);
};
